import AboutSidebar from "./AboutSidebar";
import "./About.css";
import AboutHero from "./AboutHero";

function AboutLayout({ title, image, designation, name, children }) {
  return (
    <>
      <AboutHero />

      <section className="about-detail-page">
        <div className="container py-4">
          <div className="row">
            {/* Sidebar */}

            <div className="col-lg-3 mb-4">
              <AboutSidebar />
            </div>

            {/* Content */}

            <div className="col-lg-9">
              <h2 className="page-title mb-4">{title}</h2>

              <div className="row">
                <div className="col-md-4 mb-4">
                  <img src={image} alt="" className="profile-img" />

                  <h5 className="mt-3">{name}</h5>

                  <p>{designation}</p>
                </div>

                <div className="col-md-8 page-content">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutLayout;
